module.exports = __webpack_public_path__ + "static/container.e927b60f.png";